import { PlaceholderSpan } from '../PlaceholderSpan'

export const HtmlCountIfsFunction = () => (
  <>
    <span
      data-description="Click to change function"
      data-function="countifs"
      data-type="function"
    >
      COUNTIFS
    </span>
    <span data-type="parentheses">(</span>
    <span
      data-description="Click to add initial field to range"
      data-order="0"
      data-type="addField"
    >
      add initial field
    </span>
    <span data-type="rangeSeparator">:</span>
    <span
      data-description="Click to add end field to range"
      data-order="1"
      data-type="addField"
    >
      add end field
    </span>
    <span data-type="comma">,</span>
    <PlaceholderSpan
      data-placeholder="countifs"
      placeholderProps={{
        description: 'value',
        'data-color': 'blue',
      }}
      valueProps={{
        dataDescription: 'Click and type to add a value',
        'data-type': 'value',
        'data-order': '2',
      }}
    />
    <span data-type="parentheses">)</span>
  </>
)
